import * as React from "react";
import styled from "styled-components";

import Grid from "src/library/components/Hedron";
import { Text } from "src/library/components/Text";

interface SectionProps {
  title: string;
}

const Section: React.ReactFCWithChildren<SectionProps> = ({
  title, children, ...rest
}) => (
  <SectionWrapper {...rest}>
    <Text
      as="h3"
      fontSize="h3"
    >
      {title}
    </Text>

    {children}
  </SectionWrapper>
);

const SectionWrapper = styled(Grid.Box)`
  padding: 12px 0;
  &:not(:last-of-type) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
  }
`;

export default Section;
